type Listener = (event: any) => void;

export class EventBus {
  private listeners: Map<string, Set<Listener>> = new Map();

  public on(eventName: string, listener: Listener, options?: { signal?: AbortSignal }): () => void {
    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set());
    }
    this.listeners.get(eventName)!.add(listener);

    const cleanup = () => {
      this.off(eventName, listener);
      options?.signal?.removeEventListener("abort", cleanup);
    };

    if (options?.signal) {
      if (options.signal.aborted) {
        cleanup();
      } else {
        options.signal.addEventListener("abort", cleanup);
      }
    }

    return cleanup;
  }

  public off(eventName: string, listener: Listener): void {
    const eventListeners = this.listeners.get(eventName);
    if (eventListeners) {
      eventListeners.delete(listener);
      if (eventListeners.size === 0) {
        this.listeners.delete(eventName);
      }
    }
  }

  public clearListeners(): void {
    this.listeners.clear();
  }

  public emit(eventName: string, data: any): void {
    const eventListeners = this.listeners.get(eventName);
    if (eventListeners) {
      eventListeners.forEach((listener) => {
        try {
          listener(data);
        } catch (error) {
          console.error(`Error in event listener for ${eventName}:`, error);
        }
      });
    }
  }
}
